import React from 'react';
import { BarChart, Loading } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import styles from './TestExecutionAverageTime.module.css';
import { TestExecutionDashboard } from '../interfaces/text-execution-dashboard.interface';

interface TestExecutionAverageTimeProps {
  startDate: string;
  endDate: string;
  data: TestExecutionDashboard[];
  isLoading: boolean;
  isError: boolean;
}

const TestExecutionAverageTime: React.FC<TestExecutionAverageTimeProps> = ({ startDate, endDate, data, isLoading, isError }) => {
  const chartKey = `${startDate}-${endDate}`;

  return (
    <div>
      {isLoading && (
        <div className={styles.loadingContainer}>
          <ReactEDSWrapper component={Loading} size="large" />
        </div>
      )}
      {isError && <div className={styles.loadingText}>Error while loading average test executions data.</div>}

      {!isLoading &&
        !isError &&
        data &&
        (() => {
          if (data.length === 0) {
            return (
              <div className={styles.noDataContainer}>
                <i className={`icon icon-failed ${styles.dangerIcon}`} />
                <div className={styles.noDataTitle}>Data Unavailable</div>
                <div className={styles.noDataSubtitle}>No average test executions data available for the selected time range</div>
              </div>
            );
          }

          const seriesData = data.map((d: TestExecutionDashboard) => {
            return { name: d.product_line, values: [d.duration?.toFixed(2) ?? 0] }
          });
          const chartData = {
            common: ['Product Lines'],
            series: seriesData
          };
          return (
            <div className={styles.chartContainer}>
              <ReactEDSWrapper
                key={chartKey}
                component={BarChart}
                id={`test-execution-average-time-chart-${chartKey}`}
                data={chartData}
                y={{ unit: 'Minutes' }}
                vertical 
                grouped
                barWidth={15}
                height={300}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default TestExecutionAverageTime;
